class CustomerId {
  constructor(private readonly _value: number = NaN) {
  }

  public equals(other: CustomerId): boolean {
    return (this._value === other.value);
  }

  public notEquals(other: CustomerId): boolean {
    return (this._value !== other.value);
  }

  get value() {
    return this._value;
  }
}

export default CustomerId;
